import { Icon } from './Icon';

export const SocialMediaIconsList = ({className}: {className?: string}) => {
  return (
    <div
      className={`flex flex-wrap md:flex-nowrap md:w-fit w-[86px] items-center justify-center gap-1 ${className}`}
    >
      <Icon
        name="instagram"
        width={21}
        height={21}
        className="-rotate-3 rounded-[4px] shadow-[0px_1px_5px_0px_rgba(10,13,18,0.15)]"
      />
      <Icon
        name="discord"
        width={21}
        height={21}
        className="rotate-3 rounded-[4px] shadow-[0px_1px_5px_0px_rgba(10,13,18,0.15)]"
      />
      <Icon
        name="bluesky"
        width={20}
        height={20}
        className="-rotate-3 rounded-[4px] shadow-[0px_1px_5px_0px_rgba(10,13,18,0.15)]"
      />
      <Icon
        name="twitch"
        width={20}
        height={20}
        className="rotate-3 rounded-[4px] shadow-[0px_1px_5px_0px_rgba(10,13,18,0.15)]"
      />

      <Icon
        name="steam"
        width={20}
        height={20}
        className="-rotate-3 rounded-[4px] shadow-[0px_1px_5px_0px_rgba(10,13,18,0.15)]"
      />
      <Icon
        name="itch"
        width={20}
        height={20}
        className="rotate-3 rounded-[4px] shadow-[0px_1px_5px_0px_rgba(10,13,18,0.15)]"
      />
    </div>
  );
};
